import {
    LegacyCard,
    DescriptionList,
    Page,
    Layout,
    Frame,
    TextField,
    BlockStack,
    Button,
    Checkbox
} from "@shopify/polaris";
import {useCallback, useEffect} from 'react';
import { useState } from 'react';
import {useParams, useHistory} from 'react-router-dom';
import Api from '../../helpers/api';
import {useToast} from "@shopify/app-bridge-react";

const ShowApiUser = props => {
    const history = useHistory();
    const [user, setUser] = useState(null);
    const [form, setForm] = useState({
        name: '',
        csv_inventory_access: false,
    });
    const [loading, setLoading] = useState(false);
    const {userId} = useParams();
    const toast = useToast();

    useEffect(() => {
        setLoading(true);
        Api
            .showApiUser(userId)
            .then( ({data}) => {
                setUser(data.data);
                setForm({
                    name: data.data.name,
                    csv_inventory_access: data.data.csv_inventory_access,
                })
            })
            .catch(() => toast.show("Error occurred, please try again."))
            .finally(() => setLoading(false));
    }, []);

    const refreshApiKey = () => {
        setLoading(true);
        Api
            .refreshApiUserKey(userId)
            .then( ({data}) => {
                setUser(data.data);
            })
            .catch(() => toast.show("Error occurred, please try again."))
            .finally(() => setLoading(false));
    }

    const deleteUser = () => {
        setLoading(true);
        Api
            .deleteApiUser(userId)
            .then( () => {
                toast.show("API User has been deleted");
                history.push('/api-users');
            })
            .catch(() => toast.show("Error occurred, please try again."))
            .finally(() => setLoading(false));
    }

    const handleInputChange = useCallback((value, id) => {
        setForm({
            ...form,
            [id]: value,
        });
    }, [form]);

    const save = () => {
        setLoading(true);
        Api
            .updateApiUser(userId, form)
            .then( ({data}) => {
                toast.show("API User has been updated");
                setUser(data.data);
            })
            .catch(() => toast.show("Error occurred, please try again."))
            .finally(() => setLoading(false));
    }

    return (
        <Frame>
            <Page title={`Api User`}
                  backAction={{ content: 'Go back', onAction: () => history.go(-1) }}
                  primaryAction={{
                      content: 'Save',
                      loading: loading,
                      disabled: !form.name?.length,
                      onAction() {
                          save();
                      }
                  }}
                  secondaryActions={[
                      {
                          content: "Delete",
                          loading: loading,
                          destructive: true,
                          onAction() {
                              if (confirm("Are you sure you want to delete this User? You won't be able to undo this operation!")) {
                                  deleteUser();
                              }
                          }
                      }
                  ]}
            >
                <Layout>
                    <Layout.Section variant={"fullWidth"}>
                        <LegacyCard sectioned>
                            <BlockStack gap={'200'}>
                                <DescriptionList items={[
                                    { term: 'Name', 'description': <TextField disabled={loading} label={'Name'} autoComplete={'off'} value={form.name} id={'name'} onChange={handleInputChange} /> },
                                    { term: 'Access Token', 'description': user?.api_key ?? '' },
                                    { term: 'CSV Access', 'description': <Checkbox disabled={loading} checked={form.csv_inventory_access} id={'csv_inventory_access'} onChange={handleInputChange} /> },
                                ]} />

                                <Button tone={'critical'} loading={loading} onClick={() => {
                                    if (confirm("Are you sure you want to refresh the api key? You won't be able to undo this operation!")) {
                                        refreshApiKey();
                                    }
                                }}>Refresh API Token</Button>
                            </BlockStack>
                        </LegacyCard>
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
}

export default ShowApiUser;
